// extracted by mini-css-extract-plugin
export default {"todaysWorkTimeInfo":"components-page-HomePage-__todaysWorkTimeInfo"};